// extracted by mini-css-extract-plugin
module.exports = {"row":"TextIconCards_row__n5ZKU","title":"TextIconCards_title__qaLns","content":"TextIconCards_content__iA_bd","icon":"TextIconCards_icon__Cb49n"};